import { anmClassificationCatalogZhCN } from "./anm-classification/zh-CN";
import { inspectionZhCN } from "./inspection/zh-CN";
import { regionalClassificationCatalogZhCN } from "./regional-classification/zh-CN";

export const zhCN = {
  inspection: inspectionZhCN,
  test: "如果你看到这个，i18next 正在工作！",
  operationalPermissions: {
    keys: {
      view: "查看",
      create: "创建",
      update: "编辑",
      delete: "删除",
      upload: "上传",
      download: "下载",
    },
  },
  operationalModules: {
    selector: {
      title: "选择一个结构",
      empty: "该模块暂无可用结构。",
    },
    placeholder: {
      underConstruction: "该模块正在建设中。",
    },
  },
  general: {
    comingSoon: {
      title: "即将推出",
      description: "此结构类型在总览模块中尚无仪表板。",
    },
    dashboard: {
      emptyValue: "—",
      loadError: "加载数据时出错。",
      button: {
        close: "关闭",
      },
      pagination: {
        showing: "第 {{current}} 页，共 {{total}} 页",
        previous: "上一页",
        next: "下一页",
      },
      anmClassification: {
        title: "ANM 分类",
        modalTitle: "ANM 分类表",
        dpa: "DPA",
        cri: "CRI",
        go: "GO",
        sections: {
          ct: "技术特性",
          ec: "保护状态",
          psb: "安全计划",
          dpa: "相关潜在损害",
          go: "运营管理",
        },
      },
      regionalClassification: {
        title: "区域分类",
        modalTitle: "区域分类表",
        dpa: "DPA",
        cri: "CRI",
        state: "省份:",
        norm: "规范:",
        selectionsTitle: "区域规范选择",
      },
      classificationDetail: {
        resultTitle: "分类结果",
        criteriaTitle: "评分明细",
        subtotal: "小计",
      },
      generalData: {
        title: "通用数据",
        modalTitle: "通用数据表",
        responsibleCompany: "负责公司",
        operationStartDate: "运营开始日期",
        operationEndDate: "运营结束日期",
        coordinateSystem: "坐标系统",
      },
      tenantSummary: {
        title: "GS3 / 客户",
        modalTitle: "客户信息表",
        logoAlt: "客户标志",
        clientName: "客户",
        fantasyName: "商业名称",
        cnpj: "CNPJ",
        cep: "邮政编码",
        responsibleName: "负责人",
      },
      complex: {
        title: "综合体",
        modalTitle: "综合体信息表",
        name: "综合体",
        cnpj: "CNPJ",
        cep: "邮政编码",
        responsibleName: "负责人",
      },
      hydrology: {
        title: "水文学",
      },
      raisingHistory: {
        title: "加高历史",
        modalTitle: "加高历史",
      },
      geometry: {
        title: "大坝几何结构",
        modalTitle: "几何结构表",
      },
      reservoirManagement: {
        title: "水库管理",
        modalTitle: "水库管理",
      },
      riskMapping: {
        title: "风险制图",
      },
      map: {
        title: "地图",
        noCoordinates: "未注册坐标",
      },
    },
  },
  sidebar: {
    modules: {
      general: "总览",
      monitoring: "监测",
      inspection: "检查",
      actionPlan: "行动计划",
      stabilityAnalysis: "稳定性分析",
      eor: "注册工程师 (EoR)",
      ato: "ATO",
      psb: "PSB",
      gistm: "GISTM",
      paebm: "PAEBM",
      damBreakStudy: "溃坝研究",
      riskAnalysis: "风险分析",
    },
  },
  auth: {
    selectClient: "选择客户",
    management: "管理",
    loadingOrganizations: "正在加载组织...",
    errorLoadingOrganizations: "加载组织时出错",
    errorSelectingTenant: "选择组织时出错",
    tryAgain: "重试",
    logout: "退出登录",
    loading: "加载中...",
    permissionDenied: "您没有权限",
    pagePermissionDenied: "您没有权限访问此页面。",
    authError: "验证身份验证时出错。请重试。如果问题仍然存在，请联系支持",
    permissionError: "验证权限时出错",
  },
  common: {
    notFoundPage: {
      title: "未找到页面",
      description: "抄歉，您正在寻找的页面不存在或已被移动。",
      backToHome: "返回首页",
      goBack: "返回",
    },
    tellusAllRightsReserved: "Tellus Company® 2025 版权所有",
    error: "错误",
    management: "管理",
    admin: "管理员",
    item: "项目",
    loading: "加载中...",
    deleteModalTitle: "永久删除项目",
    deleteModalItemMessage: "要删除的项目：",
    deleteModalAlertMessage: " 此操作不可逆转。删除后数据无法恢复。",
    delete: "删除",
    deleting: "删除中...",
    cancel: "取消",
    toggleTheme: "切换主题",
    deleteSuccess: "删除成功",
    createSuccess: "创建成功",
    editSuccess: "编辑成功",
    errorCreating: "创建错误",
    errorEditing: "编辑错误",
    errorDeleting: "删除错误",
    address: {
      countries: {
        brazil: "巴西",
      },
      states: {
        acre: "阿克里州",
        alagoas: "阿拉戈斯州",
        amapa: "阿马帕州",
        amazonas: "亚马孙州",
        bahia: "巴伊亚州",
        ceara: "塞阿拉州",
        distritoFederal: "联邦区",
        espiritoSanto: "圣埃斯皮里图州",
        goias: "戈亚斯州",
        maranhao: "马拉尼昂州",
        matoGrosso: "马托格罗索州",
        matoGrossoDoSul: "南马托格罗索州",
        minasGerais: "米纳斯吉拉斯州",
        para: "帕拉州",
        paraiba: "帕拉伊巴州",
        parana: "巴拉那州",
        pernambuco: "伯南布哥州",
        piaui: "皮奥伊州",
        rioDeJaneiro: "里约热内卢州",
        rioGrandeDoNorte: "北里奥格兰德州",
        rioGrandeDoSul: "南里奥格兰德州",
        rondonia: "朗多尼亚州",
        roraima: "罗赖马州",
        santaCatarina: "圣卡塔琳娜州",
        saoPaulo: "圣保罗州",
        sergipe: "塞尔希培州",
        tocantins: "托坎廷斯州",
      },
    },
  },
  pagination: {
    rowsPerPage: "每页行数",
    pageOf: "第 {{current}} 页，共 {{total}} 页",
    goToPage: "跳转到页",
    goToPageAriaLabel: "跳转到页",
    showingRange: "显示第 {{start}}–{{end}} 条，共 {{total}} 条",
    showingEmpty: "未找到记录",
  },
  management: {
    navbar: {
      management: "管理",
      users: "用户",
      clients: "客户",
      complexes: "综合体",
      structures: "结构",
      licenses: "许可证",
      log: "日志",
      releaseNotes: "发行说明",
      termsOfUse: "使用条款",
      privacyPolicy: "隐私政策",
    },
    users: {
      button: {
        new: "新建用户",
        save: "保存",
        cancel: "取消",
        edit: "编辑",
        delete: "删除",
        filter: "筛选",
        clearFilters: "清除筛选",
      },
      form: {
        label: {
          name: "姓名",
          email: "电子邮件",
          role: "访问类型",
          phone: "电话",
          department: "部门",
          position: "职位",
        },
        placeholder: {
          name: "姓名",
          email: "name@company.com",
          roleSelect: "请选择...",
          department: "数字工程",
          position: "UX/UI设计师",
          filterName: "输入姓名",
          filterEmail: "输入电子邮件",
          filterRole: "选择访问类型...",
        },
      },
      table: {
        column: {
          name: "姓名",
          email: "电子邮件",
          role: "访问类型",
        },
        filterButtonText: "筛选",
      },
      modal: {
        title: {
          create: "创建用户",
          edit: "编辑用户",
        },
      },
      filter: {
        status: {
          active: "激活",
          inactive: "未激活",
        },
      },
      validation: {
        nameRequired: "姓名为必填项",
        emailInvalid: "电子邮件无效",
        emailRequired: "电子邮件为必填项",
        roleRequired: "访问类型为必填项",
        phoneRequired: "电话为必填项",
      },
    },
    complexes: {
      button: {
        new: "新建综合体",
        save: "保存",
        cancel: "取消",
        edit: "编辑",
        delete: "删除",
        filter: "筛选",
        clearFilters: "清除筛选",
      },
      form: {
        section: {
          generalData: "基本信息",
          address: "地址",
          responsible: "负责人",
        },
        label: {
          cnpj: "CNPJ",
          tradeName: "展示名称",
          companyPhone: "公司电话",
          municipalRegistration: "市政注册",
          logo: "Logo",
          zipCode: "邮政编码",
          street: "街道",
          complement: "补充信息",
          neighborhood: "社区",
          number: "号码",
          city: "城市",
          state: "州",
          country: "国家",
          responsibleName: "负责人姓名",
          responsibleEmail: "负责人电子邮件",
          responsiblePhone: "负责人电话",
          complex: "综合体",
          phone: "电话",
          responsible: "负责人",
        },
        placeholder: {
          cnpj: "00.000.000/0000-00",
          complex: "综合体",
          tradeName: "展示名称",
          companyPhone: "(00) 00000-0000",
          municipalRegistration: "123456789",
          zipCode: "00000-000",
          street: "街道、大道等",
          complement: "房间、楼层等",
          neighborhood: "社区名称",
          number: "123",
          city: "城市名称",
          state: "选择州",
          country: "选择国家",
          responsibleName: "姓名",
          responsibleEmail: "name@company.com",
          responsiblePhone: "(00) 00000-0000",
          filterComplex: "输入综合体名称",
          filterPhone: "输入电话号码",
          filterResponsible: "输入负责人姓名",
        },
      },
      table: {
        column: {
          complex: "综合体",
          phone: "电话",
          responsible: "负责人",
        },
        filterButtonText: "筛选",
      },
      modal: {
        title: {
          create: "创建综合体",
          edit: "编辑综合体",
        },
      },
      validation: {
        cnpjRequired: "CNPJ为必填项",
        cnpjInvalid: "CNPJ无效。预期格式: 00.000.000/0000-00",
        companyRequired: "公司为必填项",
        tradeNameRequired: "展示名称为必填项",
        companyPhoneRequired: "公司电话为必填项",
        telefoneInvalid: "电话无效。预期格式: (00) 00000-0000",
        municipalRegistrationRequired: "市政注册为必填项",
        logoRequired: "Logo为必填项",
        logoInvalidType: "Logo必须是JPEG、JPG或PNG图片",
        zipCodeRequired: "邮政编码为必填项",
        zipCodeInvalid: "邮政编码无效。预期格式: 00000-000",
        streetRequired: "街道为必填项",
        neighborhoodRequired: "社区为必填项",
        numberRequired: "号码为必填项",
        numberInvalid: "请输入有效的整数",
        cityRequired: "城市为必填项",
        stateRequired: "州为必填项",
        countryRequired: "国家为必填项",
        responsibleNameRequired: "负责人姓名为必填项",
        responsibleEmailRequired: "负责人电子邮件为必填项",
        emailInvalid: "电子邮件无效",
        responsiblePhoneRequired: "负责人电话为必填项",
      },
    },
    clients: {
      button: {
        new: "新建客户",
        save: "保存",
        cancel: "取消",
        edit: "编辑",
        delete: "删除",
        filter: "筛选",
        clearFilters: "清除筛选",
      },
      form: {
        section: {
          generalData: "基本信息",
          address: "地址",
          responsible: "负责人",
        },
        label: {
          cnpj: "CNPJ",
          company: "公司",
          tradeName: "企业名称",
          companyPhone: "公司电话",
          municipalRegistration: "市政注册",
          logo: "Logo",
          zipCode: "邮政编码",
          street: "街道",
          complement: "补充信息",
          neighborhood: "社区",
          number: "号码",
          city: "城市",
          state: "州",
          country: "国家",
          responsibleName: "负责人姓名",
          responsibleEmail: "负责人电子邮件",
          responsiblePhone: "负责人电话",
          client: "客户",
          responsible: "负责人",
        },
        placeholder: {
          cnpj: "00.000.000/0000-00",
          company: "公司名称",
          tradeName: "企业名称",
          companyPhone: "(00) 00000-0000",
          municipalRegistration: "123456789",
          zipCode: "00000-000",
          street: "街道、大道等",
          complement: "房间、楼层等",
          neighborhood: "社区名称",
          number: "123",
          city: "城市名称",
          state: "选择州",
          country: "选择国家",
          responsibleName: "姓名",
          responsibleEmail: "name@company.com",
          responsiblePhone: "(00) 00000-0000",
          filterClient: "输入客户名称",
          filterTradeName: "输入企业名称",
          filterCnpj: "输入CNPJ",
          filterResponsible: "输入负责人姓名",
        },
      },
      table: {
        column: {
          client: "客户",
          tradeName: "企业名称",
          cnpj: "CNPJ",
          responsible: "负责人",
        },
        filterButtonText: "筛选",
      },
      modal: {
        title: {
          create: "创建客户",
          edit: "编辑客户",
        },
      },
      validation: {
        cnpjRequired: "CNPJ为必填项",
        cnpjInvalid: "CNPJ无效。预期格式: 00.000.000/0000-00",
        companyRequired: "公司为必填项",
        tradeNameRequired: "企业名称为必填项",
        companyPhoneRequired: "公司电话为必填项",
        telefoneInvalid: "电话无效。预期格式: (00) 00000-0000",
        municipalRegistrationRequired: "市政注册为必填项",
        logoRequired: "Logo为必填项",
        logoInvalidType: "Logo必须是JPEG、JPG或PNG图片",
        zipCodeRequired: "邮政编码为必填项",
        zipCodeInvalid: "邮政编码无效。预期格式: 00000-000",
        streetRequired: "街道为必填项",
        neighborhoodRequired: "社区为必填项",
        numberRequired: "号码为必填项",
        numberInvalid: "请输入有效的整数",
        cityRequired: "城市为必填项",
        stateRequired: "州为必填项",
        countryRequired: "国家为必填项",
        responsibleNameRequired: "负责人姓名为必填项",
        responsibleEmailRequired: "负责人电子邮件为必填项",
        emailInvalid: "电子邮件无效",
        responsiblePhoneRequired: "负责人电话为必填项",
      },
    },
    structures: {
      button: {
        new: "新建结构",
        save: "保存",
        cancel: "取消",
        edit: "编辑",
        delete: "删除",
        filter: "筛选",
        clearFilters: "清除筛选",
      },
      form: {
        section: {
          coordinates: "结构坐标",
        },
        label: {
          structure: "结构",
          name: "名称",
          complex: "综合体",
          complexName: "综合体",
          coordinateSystem: "坐标系统",
          coordinateE: "E坐标",
          coordinateN: "N坐标",
          radiusKm: "半径 (Km)",
          client: "客户",
        },
        placeholder: {
          structure: "结构名称",
          coordinateSystem: "请选择...",
          coordinateE: "E坐标",
          coordinateN: "N坐标",
          radiusKm: "0",
          name: "结构名称",
          complexSelect: "选择综合体",
          filterName: "输入结构名称",
          filterComplexName: "输入综合体名称",
          filterStructure: "输入结构名称",
          clientSelect: "选择客户",
        },
      },
      table: {
        column: {
          structure: "结构",
          name: "名称",
          complexName: "综合体",
        },
        filterButtonText: "筛选",
      },
      modal: {
        title: {
          create: "创建结构",
          edit: "编辑结构",
        },
      },
      validation: {
        nameRequired: "名称为必填项",
        complexRequired: "综合体为必填项",
        structureRequired: "结构为必填项",
        coordinateSystemRequired: "坐标系统为必填项",
        coordinateERequired: "E坐标为必填项",
        coordinateNRequired: "N坐标为必填项",
        radiusKmRequired: "半径 (Km) 为必填项",
        radiusKmMustBeNumber: "半径 (Km) 必须是数字",
      },
    },
    releaseNotes: {
      button: {
        addNewVersion: "添加新版本",
        save: "保存",
        cancel: "取消",
      },
      form: {
        label: {
          file: "文件",
          version: "文件版本",
        },
        placeholder: {
          version: "例：1.0.0",
        },
      },
      modal: {
        title: {
          create: "添加新版本",
        },
      },
      validation: {
        fileRequired: "文件为必填项",
        fileInvalidType: "文件必须是PDF格式",
        versionRequired: "版本为必填项",
      },
    },
    termsOfUse: {
      noFileUploaded: "尚未上传任何文件",
      button: {
        addNewVersion: "添加新版本",
        save: "保存",
        cancel: "取消",
      },
      form: {
        label: {
          file: "文件",
          version: "文件版本",
        },
        placeholder: {
          version: "例：1.0.0",
        },
      },
      modal: {
        title: {
          create: "添加新版本",
        },
      },
      validation: {
        fileRequired: "文件为必填项",
        fileTooLarge: "文件大小不得超过20MB",
        fileInvalidType: "文件必须是PDF格式",
      },
    },
    privacyPolicy: {
      noFileUploaded: "尚未上传任何文件",
      button: {
        addNewVersion: "添加新版本",
        save: "保存",
        cancel: "取消",
      },
      form: {
        label: {
          file: "文件",
          version: "文件版本",
        },
        placeholder: {
          version: "例：1.0.0",
        },
      },
      modal: {
        title: {
          create: "添加新版本",
        },
      },
      validation: {
        fileRequired: "文件为必填项",
        fileTooLarge: "文件大小不得超过20MB",
        fileInvalidType: "文件必须是PDF格式",
      },
    },
    log: {
      page: {
        title: "日志",
        description: "查看系统活动和审计日志。",
      },
      button: {
        export: "导出",
      },
      form: {
        label: {
          columns: "列",
          startDate: "开始日期",
          endDate: "结束日期",
        },
        placeholder: {
          columns: "选择列...",
          searchColumns: "搜索列...",
          notFound: "未找到列",
          notMoreOptions: "没有更多选项",
        },
      },
      columns: {
        user: "用户",
        action: "操作",
        date: "日期",
        ip: "IP",
        module: "模块",
      },
      validation: {
        columnsRequired: "列为必填项",
        startDateRequired: "开始日期为必填项",
        endDateRequired: "结束日期为必填项",
        dateRangeInvalid: "结束日期必须等于或晚于开始日期",
      },
    },
    licenses: {
      button: {
        new: "新建许可证",
        save: "保存",
        cancel: "取消",
        edit: "编辑",
        delete: "删除",
        view: "查看",
        filter: "筛选",
        clearFilters: "清除筛选",
      },
      form: {
        label: {
          client: "客户",
          clientEmail: "客户电子邮件",
          managerEmail: "GS3经理电子邮件",
          complex: "综合体",
          structure: "结构",
          module: "模块",
          licenses: "许可证数量",
          startDate: "开始日期",
          endDate: "结束日期",
          notificationPeriods: "通知周期",
          days: "天",
          tenant: "租户",
        },
        placeholder: {
          client: "选择客户",
          clientEmail: "email@client.com",
          managerEmail: "manager@gs3.com",
          complex: "选择综合体",
          structure: "选择结构",
          module: "选择模块",
          licenses: "0",
          notificationPeriods: "添加周期...",
          filterComplex: "输入综合体名称",
          filterStructure: "输入结构名称",
          filterModule: "选择模块",
          filterLicenses: "输入数量",
        },
      },
      table: {
        column: {
          complex: "综合体",
          structure: "结构",
          module: "模块",
          licenses: "许可证数量",
          accessPeriod: "访问周期",
        },
        filterButtonText: "筛选",
      },
      modal: {
        title: {
          create: "创建许可证",
          edit: "编辑许可证",
          view: "许可证详情",
        },
      },
      validation: {
        clientRequired: "客户为必填项",
        clientEmailRequired: "客户电子邮件为必填项",
        managerEmailRequired: "经理电子邮件为必填项",
        emailInvalid: "电子邮件无效",
        complexRequired: "综合体为必填项",
        structureRequired: "结构为必填项",
        moduleRequired: "模块为必填项",
        licensesRequired: "许可证数量为必填项",
        licensesInvalid: "请输入有效的许可证整数数量",
        startDateRequired: "开始日期为必填项",
        endDateRequired: "结束日期为必填项",
        notificationPeriodsMax: "最多3个通知周期",
        notificationPeriodAlreadyExists: "此周期已被添加",
        notificationPeriodsMin: "请添加至少1个通知期限",
      },
    },
  },
  home: {
    welcome: {
      title: "欢迎来到 GS3",
      subtitle: "请在侧边菜单中选择一个模块以开始使用。",
    },
    hero: {
      badge: "系统开发中",
      tagline: "大坝监测的未来即将到来",
      subtitle:
        "我们正在构建一个完整的大坝安全管理和监测平台。请在下方跟踪每个模块的进度。",
    },
    modules: {
      title: "系统模块",
      badgeActive: "开发中",
      badgeSoon: "即将推出",
      badgeCompleted: "已完成",
      progress: "进度",
      general: { name: "通用", description: "系统概述" },
      monitoring: { name: "监测", description: "仪器连续监测" },
      inspections: { name: "检查", description: "现场检查记录与管理" },
      actionPlan: { name: "行动计划", description: "行动计划与活动跟踪" },
      stability: { name: "稳定性", description: "边坡稳定性分析" },
      eor: { name: "EoR", description: "大坝分类与框架" },
      ato: { name: "ATO", description: "结构运营授权" },
      psb: { name: "PSB", description: "大坝安全计划" },
      gistm: { name: "GISTM", description: "全球尾矿管理标准" },
      paebm: { name: "PAEBM", description: "应急行动计划" },
      damBreak: { name: "溃坝分析", description: "溃坝模拟与自救区域" },
      riskAnalysis: { name: "风险分析", description: "风险评估与分类" },
      report: { name: "报告", description: "技术报告生成" },
      dashboard: { name: "仪表板", description: "KPI面板与指标" },
      cmg: { name: "CMG", description: "维护与控制管理" },
      managerial: { name: "管理", description: "用户、客户和许可证管理" },
      authenticationAndSecurity: {
        name: "身份验证与安全",
        description: "身份验证、授权和用户管理模块",
      },
      administrative: {
        name: "行政管理",
        description: "管理员用户的行政功能",
      },
    },
    map: {
      title: "监测覆盖区域",
    },
  },
  legalDocuments: {
    modal: {
      version: "版本",
      accept: "接受",
      termsOfUse: {
        title: "使用条款",
        readConfirm: "我已阅读并接受使用条款",
      },
      privacyPolicy: {
        title: "隐私政策",
        readConfirm: "我已阅读并接受隐私政策",
      },
    },
  },
  errors: {
    errorFallback: "意外错误",
    error1: "请求无效，请刷新页面后重试",
    error2: "用户未找到",
    error3: "您的会话已过期，请重新登录",
    error4: "请选择一个组织以继续",
    error5: "所选组织不可用",
    error6: "您无权访问此组织",
    error7: "会话已过期，请重新登录",
    error8: "您的会话已过期，请重新登录",
    error9: "无法验证您的设备，请刷新页面后重试",
    error10: "无法完成操作，请刷新页面后重试",
    error11: "该组织尚不可用，请稍后重试或联系支持",
    error12: "您没有执行此操作的权限",
    error13: "此电子邮件已注册用户",
    error14: "此CNPJ已注册环境",
    error15: "文件类型不允许",
    error16: "文件过大（最大 20 MB）",
    error17: "文件上传为必填项",
    error18: "法律文件未找到",
    error19: "您已接受此文档",
    error20: "此CNPJ已注册综合体",
    error21: "综合体未找到",
    error22: "所选综合体已存在同名结构",
    error23: "结构未找到",
    error24: "所选模块不可用",
    error25: "该结构已拥有此模块的有效许可证",
    error26: "许可证未找到",
    error27: "访问被拒绝",
    error28: "资源未找到",
    error29: "无法将此用户提升为超级管理员（已具有管理角色）",
    error30: "此用户不是超级管理员",
    error31: "该用户已是此综合体的管理员",
    error32: "许可证容量已用尽。请撤销现有分配或扩展您的计划",
    error33: "此用户已被分配此许可证",
    error34: "无法编辑此用户的权限（管理角色）",
    error35: "该模块在所选结构中不可用",
    error36: "所选模块在此上下文中无效",
    error37: "所选的一个或多个权限对此模块不存在",
    error38: "此用户角色无法分配许可证",
    error54: "保存前请填写加高历史的所有必填字段",
    error55:
      "请检查加高历史数据：高程必须为数字（如 845.25），日期必须有效，方法必须从列表中选择",
    error56: "未找到该加高历史记录",
    error77: "未找到该检查",
    error78: "未找到该检查参与者",
    error79: "筛选或分页无效，请调整条件后重试",
    error80: "无法保存，请检查检查表单后重试",
    error81: "当前状态下无法更改此检查",
    error82: "无法删除此检查",
    error83: "现在无法完成此检查",
    error84: "计划检查的日期不可更改",
    error85: "完成表单及所需证据后方可完成检查",
    error86: "所有参与者必须在完成前签名",
    error87: "无法移除此参与者",
    error88: "无法上传照片，请检查文件类型和检查状态",
    error89: "签名字体无效，请选择可用字体",
    error90: "无法生成 PDF，检查仍在进行中，请稍后再次尝试完成",
    error91: "PDF 报告尚不可用",
    error92: "请输入有效的检查日期（不能是未来日期）",
    error93: "系统中已登记的参与者姓名无法在此表单中更改",
    error94: "计划检查只能在预定当天编辑",
    error97: "该参与者已在此次巡检中",
    error98: "请求无效。请刷新页面后重试",
    error99: "请求无效。请刷新页面后重试",
    error100: "语言无效。请从菜单中选择语言后重试",
    error101: "主题无效。请刷新页面后重试",
    boundary: {
      network: {
        title: "连接错误",
        message: "无法连接到服务器。",
        suggestion: "请检查您的网络连接后重试。",
      },
      unexpected: {
        title: "意外错误",
        message: "发生意外错误，请重试。",
        suggestion: "如果问题仍然存在，请联系支持。",
      },
      unknown: {
        title: "未知错误",
        message: "发生意外错误。",
        suggestion: "请尝试重新加载页面。",
      },
      unauthorized: {
        title: "未认证",
        message: "您需要登录才能访问此页面。",
        suggestion: "请登录后重试。",
      },
      forbidden: {
        title: "访问被拒绝",
        message: "您没有权限访问此资源。",
        suggestion: "如需访问权限，请联系管理员。",
      },
      notFound: {
        title: "页面未找到",
        message: "您要找的页面不存在。",
        suggestion: "请检查地址或返回首页。",
      },
      serverError: {
        title: "服务器错误",
        message: "发生服务器内部错误。",
        suggestion: "请稍后再试。",
      },
      serviceUnavailable: {
        title: "服务不可用",
        message: "服务器暂时不可用。",
        suggestion: "我们正在努力解决这个问题。请稍后再试。",
      },
      default: {
        title: "错误",
        message: "发生意外错误。",
      },
    },
    appBoundary: {
      title: "出现了错误",
      description: "发生意外错误，请重试。",
      details: "错误详情：",
      stackTrace: "堆栈跟踪",
      retry: "重试",
      reload: "重新加载页面",
      goHome: "返回首页",
    },
  },
  admin: {
    tabs: {
      users: "用户",
      access: "访问权限",
      complexes: "综合体",
      structures: "结构",
      licenseInventory: "许可证",
      licenseAssignments: "分配",
      permissions: "权限",
    },
    access: {
      page: {
        title: "访问权限",
        subtitle: "管理哪些用户是特定综合体的管理员。",
      },
      complexAdmins: {
        sectionTitle: "综合体管理员",
        sectionDescription:
          "综合体管理员在特定综合体内拥有权限。仅 Owner 可以分配。",
        button: {
          assign: "分配综合体管理员",
          remove: "移除",
        },
        filter: {
          allComplexes: "所有综合体",
          complexLabel: "按综合体筛选",
        },
        modal: {
          assignTitle: "分配综合体管理员",
          removeTitle: "移除综合体管理员",
          removeMessage: "确定要移除此分配吗？该用户将不再管理此综合体。",
        },
        table: {
          filterButtonText: "筛选",
          column: {
            user: "用户",
            email: "邮箱",
            complex: "综合体",
            createdAt: "分配时间",
          },
          empty: "未注册分配。",
        },
      },
      form: {
        label: {
          user: "用户",
          complex: "综合体",
        },
        placeholder: {
          selectUser: "选择用户...",
          selectComplex: "选择综合体...",
        },
        validation: {
          userRequired: "请选择用户",
          complexRequired: "请选择综合体",
        },
        empty: {
          eligibleUsers: "无可选用户。",
        },
      },
      forbidden: "您没有权限查看此选项卡。",
    },
    complexes: {
      page: {
        title: "综合体",
        subtitle: "查看您租户中可用的综合体。",
      },
      button: {
        viewDetails: "查看详情",
        close: "关闭",
        filter: "筛选",
        clearFilters: "清除筛选",
      },
      table: {
        filterButtonText: "筛选",
        column: {
          name: "名称",
          fantasyName: "商标名称",
          cnpj: "CNPJ",
          responsibleName: "负责人",
        },
      },
      filter: {
        label: {
          name: "名称",
          fantasyName: "商标名称",
          cnpj: "CNPJ",
          responsibleName: "负责人",
        },
        placeholder: {
          name: "输入名称",
          fantasyName: "输入商标名称",
          cnpj: "输入 CNPJ",
          responsibleName: "输入负责人姓名",
        },
      },
      details: {
        title: "综合体详情",
        section: {
          identification: "识别信息",
          contact: "联系方式",
          address: "地址",
        },
        label: {
          name: "名称",
          fantasyName: "商标名称",
          cnpj: "CNPJ",
          municipalRegistration: "市政注册",
          complexPhone: "综合体电话",
          responsibleName: "负责人",
          responsiblePhone: "电话",
          phone: "电话",
          zipCode: "邮政编码",
          street: "街道",
          number: "门牌号",
          complement: "补充",
          neighborhood: "街区",
          city: "城市",
          state: "州",
          country: "国家",
        },
        empty: "无地址信息。",
        notProvided: "—",
        loadError: "加载综合体详情时出错。",
      },
    },
    structures: {
      page: {
        title: "结构",
        subtitle: "查看每个综合体的结构。请选择综合体开始。",
      },
      complexSelector: {
        label: "综合体",
        placeholder: "选择综合体...",
        empty: "请在上方选择综合体以查看结构。",
      },
      table: {
        filterButtonText: "筛选",
        column: {
          name: "名称",
          type: "类型",
          operationalStatus: "运营状态",
          coordinateX: "X坐标",
          coordinateY: "Y坐标",
          actions: "操作",
        },
        action: {
          details: "详情",
        },
      },
      filter: {
        label: {
          name: "名称",
          type: "类型",
          operationalStatus: "运营状态",
        },
        placeholder: {
          name: "输入名称",
          type: "选择类型",
          operationalStatus: "选择状态",
        },
        button: {
          filter: "筛选",
          clearFilters: "清除筛选",
        },
      },
      structureType: {
        dam: "大坝",
        stockpile: "堆场",
        openPit: "露天矿",
      },
      operationalStatus: {
        decommissioned: "已退役",
        underConstruction: "建设中",
        inOperation: "运营中",
        underConstructionAndOperation: "建设/运营中",
        underDecommissioning: "退役中",
        halted: "停工",
      },
      modal: {
        title: "登记结构数据",
        button: {
          close: "关闭",
          cancel: "取消",
          save: "保存",
        },
        tab: {
          generalData: "基本信息",
          raisingHistory: "加高历史",
          geometryDam: "坝体几何",
          geometry: "几何",
          hydrology: "水文",
          reservoirManagement: "水库管理",
          anmClassification: "ANM分类",
          regionalClassification: "区域分类",
          riskMapping: "风险制图",
        },
      },
      generalData: {
        label: {
          name: "名称",
          type: "类型",
          responsibleCompany: "负责企业",
          operationalStatus: "运营状态",
          operationStartDate: "运营开始",
          operationEndDate: "运营结束",
          centralPointSystem: "坐标系统",
          centralPointE: "E坐标",
          centralPointN: "N坐标",
          pinSystem: "坐标系统",
          pinE: "E坐标",
          pinN: "N坐标",
          utmEnabled: "UTM",
          utmZone: "UTM带",
          utmHemisphere: "半球",
          orthophoto: "正射影像",
        },
        section: {
          centralPointDam: "坝顶中心点坐标",
          centralPointTop: "顶部中心点坐标",
          pin: "图钉坐标",
          pinInfoTooltip:
            "可选坐标，仅用于在地图上居中显示该结构。当中心点的官方坐标在视觉上不在正中时，图钉可调整地图标记位置，且不会改变登记数据。",
          pinInfoAriaLabel: "图钉坐标说明",
        },
        coordinateSystem: {
          sirgas2000: "SIRGAS2000",
          astrochua: "ASTROCHUA",
          corregoAlegre: "CORREGO ALEGRE",
          sad69: "SAD69",
          wgs84: "WGS84",
        },
        utmHemisphere: {
          north: "北",
          south: "南",
        },
        button: {
          uploadOrthophoto: "上传正射影像",
        },
        placeholder: {
          type: "请选择类型",
          orthophoto: "选择 .tif 文件",
        },
        validation: {
          typeRequired: "请选择结构类型",
          responsibleCompanyRequired: "请输入负责企业",
          operationalStatusRequired: "请选择运营状态",
          operationStartDateRequired: "请输入运营开始日期",
          centralPointSystemRequired: "请选择中心点坐标系统",
          centralPointERequired: "请输入中心点E坐标",
          centralPointNRequired: "请输入中心点N坐标",
          pinGroupIncomplete: "请填写所有图钉字段或全部留空",
          utmZoneRequired: "请输入UTM带",
          utmHemisphereRequired: "请选择UTM半球",
          utmZoneOutOfRange: "UTM带必须在1到60之间",
          formInvalidTitle: "请填写必填字段",
          formInvalidDescription: "保存前请修正下方标出的字段。",
          decimalInvalid: "请输入有效数字（可使用小数点或逗号作为小数分隔符）",
        },
      },
      geometry: {
        label: {
          crestElevation: "坝顶高程 (m)",
          damHeight: "坝高 (m)",
          crestLength: "坝顶长度 (m)",
          crestWidth: "坝顶宽度 (m)",
          typicalBermWidth: "典型平台宽度 (m)",
          upstreamSlopeInclination: "上游坡比 (°)",
          downstreamSlopeInclination: "下游坡比 (°)",
          betweenBermsSlopeInclination: "平台间坡比 (°)",
          globalDownstreamSlopeInclination: "全局下游坡比 (°)",
          benchSlopeInclination: "台阶坡比 (°)",
          globalSlopeInclination: "全局坡比 (°)",
          pitHeight: "高度 (m)",
          sectors: "分区数",
          benchHeight: "台阶高度 (m)",
          benchInclination: "台阶倾角 (°)",
          referenceDocument: "参考文件",
        },
        validation: {
          crestElevationRequired: "请输入坝顶高程",
          damHeightRequired: "请输入坝高",
          crestLengthRequired: "请输入坝顶长度",
          crestWidthRequired: "请输入坝顶宽度",
          typicalBermWidthRequired: "请输入典型平台宽度",
          upstreamSlopeInclinationRequired: "请输入上游坡比",
          downstreamSlopeInclinationRequired: "请输入下游坡比",
          betweenBermsSlopeInclinationRequired: "请输入平台间坡比",
          globalDownstreamSlopeInclinationRequired: "请输入全局下游坡比",
          benchSlopeInclinationRequired: "请输入台阶坡比",
          globalSlopeInclinationRequired: "请输入全局坡比",
          sectorsRequired: "请输入分区数",
          sectorsInvalid: "请输入大于或等于零的整数",
          pitHeightRequired: "请输入高度",
          benchHeightRequired: "请输入台阶高度",
          benchInclinationRequired: "请输入台阶倾角",
          referenceDocumentRequired: "请输入参考文件",
          decimalInvalid: "请输入有效数字（可使用小数点或逗号作为小数分隔符）",
        },
      },
      raisingHistory: {
        label: {
          raisingCount: "加高次数",
          executiveProjectDesigner: "执行项目（设计方）",
          stage: "阶段",
          method: "方法",
          elevation: "高程 (m)",
          elevationShort: "高程",
          occurredOn: "日期",
        },
        method: {
          downstream: "下游",
          upstream: "上游",
          centerLine: "中心线",
        },
        button: {
          register: "登记",
          edit: "编辑",
          delete: "删除",
          confirm: "确认",
        },
        table: {
          filterButtonText: "筛选",
        },
        filter: {
          label: {
            stage: "阶段",
            method: "方法",
          },
          placeholder: {
            stage: "按阶段筛选",
            method: "按方法筛选",
          },
          button: {
            clearFilters: "清除筛选",
          },
        },
        modal: {
          createTitle: "新增加高",
          editTitle: "编辑加高",
          deleteTitle: "删除加高",
          deleteMessage: "是否删除此加高记录？",
        },
        validation: {
          executiveProjectDesignerRequired: "请填写执行项目（设计方）",
          stageRequired: "请填写阶段",
          methodRequired: "请选择方法",
          elevationRequired: "请填写高程",
          elevationInvalid: "高程请仅填写数字，单位为米（如 845.25）",
          occurredOnRequired: "请填写日期",
          occurredOnInvalid: "请填写有效日期",
        },
      },
      reservoirManagement: {
        label: {
          occupiedArea: "水库占用面积 (m²)",
          occupiedAreaShort: "占用面积 (m²)",
          totalVolume: "水库总容积 (m³)",
          totalVolumeShort: "总容积 (m³)",
          totalOccupiedVolume: "总占用容积 (m³)",
          totalOccupiedVolumeShort: "总占用容积 (m³)",
          availableVolume: "可用容积 (m³)",
          availableVolumeShort: "可用容积 (m³)",
          rejectOccupiedVolume: "尾矿占用容积 (m³)",
          rejectOccupiedVolumeShort: "尾矿占用容积 (m³)",
          waterOccupiedVolume: "水占用容积 (m³)",
          waterOccupiedVolumeShort: "水占用容积 (m³)",
          waterLevel: "水位",
          recordedOn: "日期",
        },
        button: {
          register: "登记",
          edit: "编辑",
          delete: "删除",
          confirm: "确认",
        },
        table: {
          filterButtonText: "筛选",
        },
        filter: {
          label: {
            recordedOn: "日期",
          },
          button: {
            clearFilters: "清除筛选",
          },
        },
        modal: {
          createTitle: "新建管理记录",
          editTitle: "编辑管理记录",
          deleteTitle: "删除管理记录",
          deleteMessage: "是否删除此管理记录？",
        },
        validation: {
          occupiedAreaRequired: "请填写水库占用面积",
          occupiedAreaInvalid: "占用面积只能填写数字",
          totalVolumeRequired: "请填写水库总容积",
          totalVolumeInvalid: "总容积只能填写数字",
          totalOccupiedVolumeRequired: "请填写总占用容积",
          totalOccupiedVolumeInvalid: "总占用容积只能填写数字",
          availableVolumeRequired: "请填写可用容积",
          availableVolumeInvalid: "可用容积只能填写数字",
          rejectOccupiedVolumeRequired: "请填写尾矿占用容积",
          rejectOccupiedVolumeInvalid: "尾矿占用容积只能填写数字",
          waterOccupiedVolumeRequired: "请填写水占用容积",
          waterOccupiedVolumeInvalid: "水占用容积只能填写数字",
          waterLevelRequired: "请填写水位",
          waterLevelInvalid: "水位只能填写数字",
          recordedOnRequired: "请填写日期",
          recordedOnInvalid: "请填写有效日期",
        },
      },
      anmClassification: {
        classification: {
          high: "高",
          medium: "中",
          low: "低",
        },
        label: {
          criBignumberTitle: "风险分类 (CRI)",
          dpaBignumberTitle: "关联潜在损害 (DPA)",
          goBignumberTitle: "运营管理 (GO)",
          referenceDocButton: "参考文档 {{section}}",
          referenceDocPanel: "参考文档 — {{section}}",
          close: "关闭",
          total: "总计 {{section}}",
          classificationStatus: "分类 {{section}}",
          partial: "部分 {{grade}}",
          points: "分数",
          classification: "分类",
          criterion: "标准",
          band: "区间",
          riskCategory: "风险类别",
          riskCategoryCri: "风险类别 (CRI)",
        },
        criPanel: {
          tableTitle: "表 1 - 矿山坝分类",
          ctRow: "技术特征 (CT)",
          ecRow: "保护状况 (EC)",
          psRow: "坝安全计划 (PS)",
          totalFormula: "总分 (CRI) = CT + EC + PS",
          riskClassification: "风险分类",
          bandsTitle: "分类区间",
          bandHigh: ">= 80 或 EC = 10 (*)",
          bandMedium: "40 < CRI < 80",
          bandLow: "<= 40",
          footnote:
            "(*) 保护状况 (EC) 任一列得分为 (10) 时，自动归为高风险类别，坝负责人须立即采取预防措施",
        },
        dpaPanel: {
          tableTitle: "采矿大坝分类",
          damageCategoryDpa: "关联潜在损害 (DPA)",
          volumeRow: "水库总容积",
          populationRow: "下游人口存在情况",
          environmentalRow: "环境影响",
          socioeconomicRow: "社会经济影响",
          totalLabel: "总分 (DPA)",
          damageClassification: "损害分类",
          bandsTitle: "分类区间",
          damageCategory: "关联潜在损害",
          bandHigh: ">= 13",
          bandMedium: "7 < DPA < 13",
          bandLow: "<= 7",
          matrixFooter: "分类矩阵",
        },
        goClassification: {
          aa: "AA",
          a: "A",
          b: "B",
          c: "C",
          d: "D",
        },
        goPanel: {
          tableTitle: "表 6 - 运营管理分类",
          operationalCategory: "运营管理 (GO)",
          risrRow: "已提交 RISR 稳定状况声明",
          rpsbRow: "已提交 RPSB 稳定状况声明",
          conformityRow: "已提交合规与运营声明",
          inspectionRow: "已提交检查摘要",
          edrRow: "是否存在注册工程师 (EdR)",
          pgrbmRow: "矿山坝风险管理计划 — PGRBM",
          certificationRow: "行业认证和/或标准",
          totalLabel: "总分 (GO)",
          operationalClassification: "运营管理分类",
          bandsTitle: "分类区间",
          gopCategory: "GOP",
          bandAa: "0",
          bandA: "1 至 7",
          bandB: "8 至 35",
          bandC: "36 至 59",
          bandD: ">= 60 (*)",
          footnote:
            "(*) 应登记于 CNBM 但在执法行动中被发现的坝，将在随后 6 个月内保持 D 类。",
        },
        validation: {
          incompleteSelectionTitle: "选择不完整",
          incompleteSelectionDescription:
            "保存前请在所有等级（CRI、DPA 和运营管理）的每一列中各选择一张卡片。",
        },
        catalog: anmClassificationCatalogZhCN,
      },
      regionalClassification: {
        classification: {
          high: "高",
          medium: "中",
          low: "低",
        },
        state: {
          label: "州",
          placeholder: "请选择州",
          mg: "米纳斯吉拉斯州",
        },
        norm: {
          label: "规范",
          placeholder: "请选择规范",
          locked: "首次保存后规范已锁定。",
        },
        label: {
          criBignumberTitle: "风险类别（CRI）",
          secondBignumberTitle: "潜在损害",
          referenceDocButton: "参考文档 {{section}}",
          referenceDocPanel: "参考文档 — {{section}}",
          close: "关闭",
          total: "合计 {{section}}",
          classificationStatus: "分类 {{section}}",
          partial: "小计 {{grade}}",
          points: "分数",
          classification: "分类",
          criterion: "标准",
          band: "区间",
          riskCategory: "风险类别",
          riskCategoryCri: "风险类别 (CRI)",
        },
        criPanel: {
          sectionRowNumber: "1",
          gradeRowNumber: "1.{{index}}",
          totalFormula: "总分 (CRI) = CT + EC + PSB",
          bandsTitle: "分类区间",
          bandHigh: ">= {{highMin}} 或 EC = {{ecScore}} (*)",
          bandMedium: "{{mediumMin}} < CRI < {{highMin}}",
          bandLow: "<= {{mediumMin}}",
          footnote:
            "(*) 任一 conservation state (EC) 列得分达到 ({{ecScore}}) 或以上时，自动判定为高风险类别，坝主须立即采取预防措施",
        },
        secondPanel: {
          sectionRowNumber: "2",
          criterionRowNumber: "2.{{index}}",
          damageCategory: "关联潜在损害 ({{section}})",
          totalLabel: "总分 ({{section}})",
          damageClassification: "损害分类",
          bandsTitle: "分类区间",
          bandHigh: ">= {{highMin}}",
          bandMedium: "{{mediumMin}} < {{section}} < {{highMin}}",
          bandLow: "<= {{mediumMin}}",
          matrixFooter: "分类矩阵",
        },
        validation: {
          incompleteSelectionTitle: "选择不完整",
          incompleteSelectionDescription:
            "保存前请在所有网格（CRI 和 PDA/DPA）的每一列中各选择一张卡片。",
          stateRequired: "请选择州",
          normRequired: "请选择规范",
          normLocked: "首次保存后规范不可更改。",
        },
        catalog: regionalClassificationCatalogZhCN,
      },
      riskMapping: {
        label: {
          wasteType: "废物类型",
          downstreamHumanOccupation: "坝址下游人类占用情况",
          downstreamEnvironmentalInterest: "坝址下游环境利益",
          downstreamInstallation: "坝址下游设施",
        },
        validation: {
          wasteTypeRequired: "请填写废物类型",
          downstreamHumanOccupationRequired: "请填写坝址下游人类占用情况",
          downstreamEnvironmentalInterestRequired: "请填写坝址下游环境利益",
          downstreamInstallationRequired: "请填写坝址下游设施",
        },
      },
      hydrology: {
        label: {
          maximumMaximorumLevel: "最高水位（maximorum） (m)",
          criticalDuration: "临界持续时间 (h)",
          inflowRate: "入库流量 (m³/s)",
          outflowRate: "出库流量 (m³/s)",
          designRainfall: "设计降雨 (mm)",
          contributingBasinArea: "汇水面积 (km²)",
          returnPeriod: "重现期 (年)",
          totalVolumeAtCrestElevation: "坝顶高程总库容 (m³)",
          spillwayType: "溢洪道类型",
          spillwaySill: "溢洪道底槛 (mm)",
          referenceDocument: "参考文件",
        },
        spillwayType: {
          surface: "表面",
          tulip: "郁金香型",
          lateralChannel: "侧槽",
          labyrinth: "迷宫式",
          gated: "闸门控制",
          bottom: "底孔",
        },
        validation: {
          maximumMaximorumLevelRequired: "请输入最高水位（maximorum）",
          criticalDurationRequired: "请输入临界持续时间",
          inflowRateRequired: "请输入入库流量",
          outflowRateRequired: "请输入出库流量",
          designRainfallRequired: "请输入设计降雨",
          contributingBasinAreaRequired: "请输入汇水面积",
          returnPeriodRequired: "请输入重现期",
          totalVolumeAtCrestElevationRequired: "请输入坝顶高程总库容",
          spillwayTypeRequired: "请选择溢洪道类型",
          spillwaySillRequired: "请输入溢洪道底槛",
          referenceDocumentRequired: "请输入参考文件",
          decimalInvalid: "请输入有效数字（可使用小数点或逗号作为小数分隔符）",
        },
      },
    },
    users: {
      button: {
        new: "新用户",
        save: "保存",
        cancel: "取消",
        edit: "编辑",
        delete: "删除",
        filter: "筛选",
        clearFilters: "清除筛选",
      },
      form: {
        label: {
          name: "姓名",
          email: "邮箱",
          phone: "电话",
          department: "部门",
          position: "职位",
          userType: "用户类型",
        },
        placeholder: {
          name: "姓 名",
          email: "name@company.com",
          emailTellus: "ming.xing@telluscompany.com.br",
          userTypeSelect: "请选择...",
          department: "数字工程",
          position: "UX/UI 设计师",
          filterName: "输入姓名",
          filterEmail: "输入邮箱",
        },
      },
      table: {
        filterButtonText: "筛选",
        column: {
          name: "姓名",
          email: "邮箱",
          role: "访问类型",
          userType: "类型",
          department: "部门",
          position: "职位",
        },
      },
      modal: {
        title: {
          create: "创建用户",
          edit: "编辑用户",
        },
      },
      userType: {
        client: "客户",
        tellus: "Tellus",
      },
      validation: {
        nameRequired: "姓名为必填项（最少 2 个字符）",
        emailRequired: "邮箱为必填项",
        emailInvalid: "邮箱无效",
        emailTellusDomain: "邮箱必须属于 @telluscompany.com.br 域名",
        phoneRequired: "电话为必填项（最少 8 个字符）",
      },
    },
    licenseInventory: {
      page: {
        title: "许可证库存",
        subtitle:
          "按综合体、结构和模块查看已签约的许可证,包含总数、已使用和可用数量。",
      },
      table: {
        filterButtonText: "筛选",
        column: {
          complex: "综合体",
          structure: "结构",
          module: "模块",
          validity: "有效期",
          quantity: "总数",
          used: "已使用",
          available: "可用",
        },
      },
      filter: {
        label: {
          complex: "综合体",
          structure: "结构",
          module: "模块",
          onlyActive: "仅显示有效许可证",
        },
        placeholder: {
          complex: "输入综合体名称",
          structure: "输入结构名称",
          module: "输入模块名称",
        },
        button: {
          filter: "筛选",
          clearFilters: "清除筛选",
        },
      },
    },
    licenseAssignments: {
      page: {
        title: "许可证分配",
        subtitle:
          "为租户用户分配和撤销许可证。每次分配会消耗一个签约数量单位。",
      },
      button: {
        assign: "分配许可证",
        revoke: "撤销",
      },
      table: {
        filterButtonText: "筛选",
        column: {
          assigneeName: "用户",
          assigneeEmail: "邮箱",
          complex: "综合体",
          structure: "结构",
          module: "模块",
          validity: "有效期",
        },
      },
      filter: {
        label: {
          complex: "综合体",
          structure: "结构",
          module: "模块",
          user: "用户",
        },
        placeholder: {
          complex: "输入综合体名称",
          structure: "输入结构名称",
          module: "输入模块名称",
          user: "输入用户名称",
        },
        button: {
          filter: "筛选",
          clearFilters: "清除筛选",
        },
      },
      modal: {
        assignTitle: "分配许可证",
        revokeTitle: "撤销分配",
        revokeMessage: "确定要撤销此分配吗?该许可证将重新变为可用。",
      },
      form: {
        label: {
          user: "用户",
          license: "许可证(综合体 / 结构 / 模块)",
        },
        placeholder: {
          selectUser: "请选择用户...",
          selectLicense: "请选择许可证...",
        },
        validation: {
          userRequired: "请选择一个用户",
          licenseRequired: "请选择一个许可证",
        },
        licenseOption: {
          available: "可用",
        },
        licenseEmpty: "没有可用的有效许可证。",
      },
    },
    permissions: {
      page: {
        title: "细粒度权限",
        subtitle:
          "为每个用户定义其在特定结构中各模块可以执行的操作。",
      },
      form: {
        label: {
          complex: "综合体",
          structure: "结构",
          user: "用户",
        },
        placeholder: {
          selectComplex: "请选择综合体...",
          selectStructure: "请选择结构...",
          selectUser: "请选择用户...",
        },
      },
      empty: {
        selectAll: "请选择综合体、结构和用户以继续。",
      },
      error: {
        load: "加载权限时出错。请确认您对所选综合体有访问权限。",
      },
      grid: {
        empty: "此组合下没有可用模块。",
        badge: {
          unavailable: "在此结构中不可用",
        },
        module: {
          noKeys: "该模块未定义任何权限键。",
        },
      },
      button: {
        save: "保存权限",
      },
    },
  },
};
